import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'replaceHash',
	standalone: true
})
export class ReplaceHashPipe implements PipeTransform {

	transform(str?: string) {
		return str?.replace('#', `□`).replace('¤', `○`);
	}

}
